import { render, staticRenderFns } from "./addStudentAndClassTypeDialog.vue?vue&type=template&id=6fe04bc0&scoped=true&"
import script from "./addStudentAndClassTypeDialog.vue?vue&type=script&lang=js&"
export * from "./addStudentAndClassTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./addStudentAndClassTypeDialog.vue?vue&type=style&index=0&id=6fe04bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe04bc0",
  null
  
)

export default component.exports